import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/slice";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import React from 'react';
export var SlideList = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _context2;

  var items = props.items,
      parentPrefixCls = props.parentPrefixCls;
  var slideListPrefixCls = "".concat(parentPrefixCls, "-list-slide");
  var listPrefixCls = "".concat(parentPrefixCls, "-list");

  var renderItems = function renderItems() {
    var _context;

    var _items = _concatInstanceProperty(_context = _sliceInstanceProperty(items).call(items, -1)).call(_context, items, _sliceInstanceProperty(items).call(items, 0, 1)); // 首位分别添加一项


    return _mapInstanceProperty(_items).call(_items, function (item, index) {
      return /*#__PURE__*/React.createElement("li", {
        className: "".concat(listPrefixCls, "-item"),
        key: index
      }, item);
    });
  };

  return /*#__PURE__*/React.createElement("ul", {
    className: _concatInstanceProperty(_context2 = "".concat(listPrefixCls, " ")).call(_context2, slideListPrefixCls),
    ref: ref
  }, renderItems());
});